import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402';

export interface ContentTag {
  id: string;
  name: string;
  slug: string;
  description?: string;
  isActive: boolean;
  postsCount: number;
  creatorsCount: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface BlockedContent {
  id: string;
  contentId: string;
  contentType: 'POST' | 'COMMENT' | 'USER';
  reason: string;
  blockedBy: string;
  isActive: boolean;
  blockedAt: Date;
}

export const contentManagementService = {
  // Content Tags
  async getContentTags() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_URL}/api/admin/content-tags`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.tags as ContentTag[];
  },

  async createContentTag(data: {
    name: string;
    slug: string;
    description?: string;
    isActive?: boolean;
  }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_URL}/api/admin/content-tags`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.tag as ContentTag;
  },

  async updateContentTag(id: string, data: {
    name: string;
    slug: string;
    description?: string;
    isActive?: boolean;
  }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_URL}/api/admin/content-tags/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.tag as ContentTag;
  },

  async deleteContentTag(id: string) {
    const token = localStorage.getItem('accessToken');
    await axios.delete(`${API_URL}/api/admin/content-tags/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // Blocked Content
  async getBlockedContent() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_URL}/api/admin/blocked-content`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.blockedContent as BlockedContent[];
  },

  async blockContent(data: {
    contentId: string;
    contentType: 'POST' | 'COMMENT' | 'USER';
    reason: string;
  }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_URL}/api/admin/blocked-content`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.blockedItem as BlockedContent;
  },

  async unblockContent(id: string) {
    const token = localStorage.getItem('accessToken');
    await axios.delete(`${API_URL}/api/admin/blocked-content/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};